import { AddInputAcknowledgement } from "../../../domain/useages/user-input-acknowledgement/add-user-input-acknowledgement";
import { AddUserManagerReturnPos } from "../../../domain/useages/user-return-acknowledgement/add-user-manager-return-acknowledgement";
import { HttpConstants } from "../../protocols/http/http-constants";
import { HttpPostClient } from "../../protocols/http/http-post-client";

export class RemoteAddUserManagerReturnAcknowledgement
  implements AddUserManagerReturnPos
{
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpPostClient
  ) {}

  async add(params: AddUserManagerReturnPos.Params): Promise<any> {
    const httpResponse = await this.httpPostClient.post({
      url: this.url,
      body: params,
      headers: {
        [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
        [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
         [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
      },
      authHeaders: true,
    });
    if (httpResponse.status === 200) {
      return httpResponse.data;
    }
  }
}
